module.exports = __webpack_public_path__ + "media/images/icon/icons8-Support-70804e441219ffeba1de314cff755e56.png";